import { Reveal, SectionHeading } from "./Reveal";
import { ABOUT_POINTS, COMPANY } from "@/data/site";

const ABOUT_IMAGE =
  "https://images.pexels.com/photos/8134103/pexels-photo-8134103.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const About = () => (
  <section id="about" data-testid="about-section" className="scroll-mt-24 bg-white py-24 md:py-32 lg:py-40">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 md:px-12 lg:grid-cols-2">
      <div>
        <SectionHeading
          overline="About Prata Technologies"
          title="Technology Built Around Your Business"
        />
        <Reveal delay={0.1}>
          <div className="mt-6 space-y-5 text-base leading-relaxed text-slate-600">
            <p>
              {COMPANY.name} is a UK-based technology company focused on AI,
              automation, software development and digital transformation.
            </p>
            <p>
              We help businesses move beyond manual processes by combining
              artificial intelligence, automation and modern digital technologies.
            </p>
            <p>
              From AI-powered customer service and WhatsApp automation to websites,
              applications and custom business workflows, we create practical
              technology solutions designed around real business needs. We work with
              businesses across the UK and India.
            </p>
          </div>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3">
          {ABOUT_POINTS.map((point, i) => (
            <Reveal key={point.label} delay={0.1 + i * 0.06}>
              <div
                data-testid={`about-point-${i}`}
                className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
              >
                <point.icon className="h-4 w-4 shrink-0 text-electric" strokeWidth={1.5} />
                <span className="text-xs font-medium text-slate-700">{point.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="relative overflow-hidden rounded-3xl shadow-2xl">
          <img
            src={ABOUT_IMAGE}
            alt="Prata Technologies team collaborating on AI and digital solutions"
            className="h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-950/60 via-transparent to-transparent" />
        </div>
        <div className="glass-chip absolute -bottom-6 -left-4 rounded-2xl bg-navy-950/90 px-6 py-5 shadow-xl md:-left-8">
          <p className="text-xs uppercase tracking-[0.2em] text-slate-400">Registered in the UK</p>
          <p className="mt-1 font-display text-lg text-white">
            Company No. <span className="text-electric-bright">{COMPANY.companyNumber}</span>
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
